import styles from './FeatureContents.module.css';

/**
 * @component ActorDBContent
 * @description 배우 DB 카드 내용
 */
function ActorDBContent() {
  const actors = [
    { id: 1, name: '김민지', color: '#E8C4A0' },
    { id: 2, name: '이준호', color: '#B0C4DE' },
    { id: 3, name: '박서연', color: '#C4E8C4' },
    { id: 4, name: '최우진', color: '#E8C4C4' },
  ];

  return (
    <div className={styles.actorDBContent}>
      <div className={styles.actorPhotoGrid}>
        {actors.map((actor) => (
          <div key={actor.id} className={styles.actorPhotoItem}>
            <div className={styles.actorAvatar} style={{ backgroundColor: actor.color }}>
              {actor.name[0]}
            </div>
            <span className={styles.actorName}>{actor.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ActorDBContent;
